'use strict';

import { appState, callDynEvents } from '../appState.js';
import { ModalManager, trapFocus } from '../ModalManager.js';
import { transGet } from '../transTools.js';

export const wmmCalendarModal = {
    disableScroll: true,
    historyLevel: 0,
    historyParam: 'wmmcalendar',
    modalManagerToken: null,
    $field: null,
    $dialog: null,
    onSelectCallback: null,
    onCloseCallback: null,
    focusTrap: null,
    isOpen: false,

    yearsList: null,
    years: {},

    init: function(options) {
        // Šeit var pievienot kodu, kas inicializē kalendāra modālo logu
        console.log('Kalendāra modālais logs inicializēts ar opcijām:', options);

        this.historyLevel = 0;
        this.result = null;
        this.button = options.button;
        this.date = options.date;

        this.onSelectCallback = options.onSelect || null;
        this.onCloseCallback = options.onClose || null;

        this.selectedFilter = options.selectedFilter || 1;

        if (!this.$dialog) {
            // Paņemam template saturu un klonējam (Native JS šeit ir labāks par jQuery)
            const tpl = /** @type {HTMLTemplateElement} */ (document.getElementById('tpl-miracleCalendarModal'));
            const clone = /** @type {DocumentFragment} */ (tpl.content.cloneNode(true));

            this.$field = $(clone.firstElementChild); // Pieņemot, ka template satur tikai vienu root elementu
            this.$dialog = this.$field.find('.infoBox');
            this.dialog = this.$dialog.get(0);
            $('body').append(clone);

            this.labels = JSON.parse(document.getElementById('miracleCalendarModalLabels').textContent);

            this.bindEvents(); // Piesienam klikšķus tikai vienreiz!
        }

        this.renderCalendar(this.date);

        this.open();
    },

    destroy: function() {
        this.dialog.removeEventListener('click', this.clickHandler);
        this.clickHandler = null;

        document.removeEventListener('click', this.outclickHandler);
        this.outclickHandler = null;

        document.removeEventListener('mousedown', this.mousedownCarouselHandler);
        document.removeEventListener('mousemove', this.mousemoveCarouselHandler);
        document.removeEventListener('mouseup', this.mouseupCarouselHandler);
        document.removeEventListener('click', this.clickCarouselHandler, true);
        document.removeEventListener('keydown', this.keydownCarouselHandler);
        document.removeEventListener('focusin', this.focusinCarouselHandler);
        this.clickCarouselHandler = null;
        this.keydownCarouselHandler = null;
        this.focusinCarouselHandler = null;
        this.mousedownCarouselHandler = null;
        this.mousemoveCarouselHandler = null;
        this.mouseupCarouselHandler = null;

        this.$field.find('#filter-miracles-count').off('select2:select');

        if (this.focusTrap) {
            this.focusTrap.destroy();
            this.focusTrap = null;
        }

        if (this.$field) {
            this.$field.remove();
            this.$field = null;
            this.$dialog = null;
            this.dialog = null;
        }
        this.onSelectCallback = null;
        this.onCloseCallback = null;
        this.focusTrap = null;
        this.isOpen = false;
    },

    bindEvents: function() {
        const self = this;

        this.clickHandler = (event) => {
            const target = event.target;
            if (target.tagName === 'BUTTON') {
                const action = target.closest('[data-action]');
                if (action) {
                    const actionType = action.getAttribute('data-action');
                    if (typeof self.actions[actionType] === 'function') {
                        self.actions[actionType].call(self, target);
                    }
                }
            }
        };

        this.outclickHandler = (event) => {
            if (!this.dialog.contains(event.target)) {
                this.close();
            }
        };

        this.dialog.addEventListener('click', this.clickHandler);
        document.addEventListener('click', this.outclickHandler);

        this.$field.find('#filter-miracles-count').select2({
            dropdownParent: this.$field,
            width: '100%',
            minimumResultsForSearch: -1
        }).on('select2:select', function (e) {
            // Šeit var pievienot kodu, kas tiek izpildīts, kad tiek izvēlēta opcija
            self.actions.selectFilter.call(self, e.target.value);
        });


        // Karuseļu handleri visi uz document; karuselis tiek noteikts pēc target
        const DRAG_THRESHOLD = 5; // px, pēc kura sākas drag un klikšķis tiek nobloķēts
        let downCarousel = null;
        let startX = 0;
        let scrollLeft = 0;
        let isDragging = false;
        let suppressClick = false;

        const getCarousel = (target) => {
            const carousel = target instanceof Element ? target.closest('.x-carousel') : null;
            return carousel && this.dialog && this.dialog.contains(carousel) ? carousel : null;
        };

        this.clickCarouselHandler = (e) => {
            const carousel = getCarousel(e.target);
            if (!carousel) return;
            const target = e.target.closest('button');
            if (suppressClick) {
                suppressClick = false;
                e.preventDefault();
                e.stopImmediatePropagation();
                return;
            }
            if (target) {
                carousel.querySelector('.selected')?.classList.remove('selected');
                target.classList.add('selected');

                target.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center', // Iespējas: 'center', 'nearest', 'start'
                    block: 'nearest'
                });
            }
        };
        this.keydownCarouselHandler = (e) => {
            const target = e.target;
            const carousel = getCarousel(target);
            if (carousel && target.tagName === 'BUTTON') {
                const carousels = this.dialog.querySelectorAll('.x-carousel');
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    target.click();
                }
                else if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    const prev = target.closest('li').previousElementSibling?.querySelector('button');
                    if (prev && prev.tagName === 'BUTTON') {
                        prev.focus();
                        prev.scrollIntoView({
                            behavior: 'smooth',
                            inline: 'center', // Iespējas: 'center', 'nearest', 'start'
                            block: 'nearest'
                        });
                    }
                }
                else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    const next = target.closest('li').nextElementSibling?.querySelector('button');
                    if (next && next.tagName === 'BUTTON') {
                        next.focus();
                        next.scrollIntoView({
                            behavior: 'smooth',
                            inline: 'center', // Iespējas: 'center', 'nearest', 'start'
                            block: 'nearest'
                        });
                    }
                }
                else if (e.key === 'ArrowUp') {
                    if (carousel.classList.contains('month-carousel')) {
                        e.preventDefault();
                        // no mēnesi fokusējam uz year;
                        Array.from(carousels).filter(c => c.classList.contains('year-carousel')).forEach(c => {
                            c.querySelector('button.selected')?.focus();
                        });
                    }
                }
                else if (e.key === 'ArrowDown') {
                    if (carousel.classList.contains('year-carousel')) {
                        e.preventDefault();
                        // no year fokusējam uz month;
                        Array.from(carousels).filter(c => c.classList.contains('month-carousel')).forEach(c => {
                            c.querySelector('button.selected')?.focus();
                        });
                    }
                    else if (carousel.classList.contains('month-carousel')) {
                        e.preventDefault();
                        console.log('ArrowDown pressed on month-carousel');
                        // no month fokusējam uz izvēlēto datumu vai pirmo datumu;
                        const daysContainer = this.dialog.getElementsByClassName('calendar-dyn-container')[0];
                        const selectedDay = daysContainer.querySelector('button.selected');
                        if (selectedDay) {
                            selectedDay.focus();
                        } else {
                            const firstDay = daysContainer.querySelector('button');
                            firstDay?.focus();
                        }
                    }
                }
                else if (e.key === 'Tab') {
                    // Tab key handling is already managed by the trapFocus function
                    console.log('Tab key pressed', e);
                }
            }
        };
        this.focusinCarouselHandler = (e) => {
            const target = e.target;
            if (getCarousel(target) && target.tagName === 'BUTTON' && target.matches(':focus-visible')) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center', // Iespējas: 'center', 'nearest', 'start'
                    block: 'nearest'
                });
            }
        };

        this.mousedownCarouselHandler = (e) => {
            if (e.button !== 0) return;
            const carousel = getCarousel(e.target);
            if (!carousel) return;
            downCarousel = carousel;
            isDragging = false;
            suppressClick = false;
            startX = e.pageX;
            scrollLeft = carousel.scrollLeft;
        };
        this.mousemoveCarouselHandler = (e) => {
            if (!downCarousel) return;
            const dx = e.pageX - startX;
            if (!isDragging) {
                if (Math.abs(dx) < DRAG_THRESHOLD) return;
                isDragging = true;
                downCarousel.classList.add('dragging');
            }
            e.preventDefault();
            downCarousel.scrollLeft = scrollLeft - dx;
        };
        this.mouseupCarouselHandler = () => {
            if (!downCarousel) return;
            downCarousel.classList.remove('dragging');
            downCarousel = null;
            if (isDragging) {
                isDragging = false;
                // click tiek nobloķēts; atmetam karogu, ja click neseko (mouseup ārpus elementa)
                suppressClick = true;
                setTimeout(() => { suppressClick = false; }, 0);
            }
        };

        // click capture fāzē, lai drag beigās nenotiek ne selekcija, ne citi click handleri
        document.addEventListener('mousedown', this.mousedownCarouselHandler);
        document.addEventListener('mousemove', this.mousemoveCarouselHandler);
        document.addEventListener('mouseup', this.mouseupCarouselHandler);
        document.addEventListener('click', this.clickCarouselHandler, true);
        document.addEventListener('keydown', this.keydownCarouselHandler);
        document.addEventListener('focusin', this.focusinCarouselHandler);

        appState.historyInstance.add(this.historyParam, {
            value: null,
            backCallback: function (change) {
                try {
                    if (self.historyLevel > change.to) {
                        self.backTo(change.to, true);
                    }
                    //self.close(true);
                } catch (e) {

                }
            },
            checkCallback: function (value) {
                try {
                    if (self.historyLevel >= 1) {
                        return self.historyLevel;
                    }
                } catch (e) {

                }
                return null;
            },
            refreshCallback: function (urlState, currentState) {
                let countAdd = urlState > currentState ? (urlState - (currentState || 0)) : 1;
                return countAdd;
            },
            disableNext: true,
            goBackOnRefresh: true
        });
    },

    actions: {
        close: function () {
            this.close();
        },
        submit: function () {
            if (typeof this.onSelectCallback === 'function') {
                this.onSelectCallback(this.result);
            }
            this.close();
        },
        selectFilter: function (val) {
            // Šeit var pievienot kodu, kas tiek izpildīts, kad tiek izvēlēta opcija filtrā
            this.selectedFilter = parseInt(val, 10);
            console.log('Filter selected:', this.selectedFilter);

            // TODO: refresh the calendar based on the selected filter
        },
        selectYear: function (btn) {
            const newYear = parseInt(btn.getAttribute('data-year'), 10);
            const prevYear = this.opened.year;
            if (newYear == prevYear) {
                return;
            }
            this.opened.year = newYear;
            this.opened.month = newYear < prevYear ? 12 : 1;

            console.log('Year selected:', newYear, 'Previous year:', prevYear);
            console.log('Opened month set to:', this.opened.month);
            this.openYear();
        },
        selectMonth: function (btn) {
            const newMonth = parseInt(btn.getAttribute('data-month'), 10);
            const prevMonth = this.opened.month;
            if (newMonth == prevMonth) {
                return;
            }
            this.opened.month = newMonth;
            console.log('Month selected:', newMonth, 'Previous month:', prevMonth);
            this.openMonth();
        },
        selectDate: function (btn) {
            const newDate = parseInt(btn.textContent, 10);
            this.selected.day = newDate;
            this.selected.year = this.opened.year;
            this.selected.month = this.opened.month;
            this.selected.date = new Date(this.selected.year, this.selected.month - 1, this.selected.day);

            this.dialog.querySelector('.calendar-day.usable.selected')?.classList.remove('selected');
            btn.classList.add('selected');
            this.renderSelected();

            console.log('Date selected:', newDate);
            // TODO: refresh the calendar based on the selected date
        }
    },
    transformDays: function(days) {
        const transformed = {};
        console.log('Transforming days:', days);
        for (const key in days) {
            if (days.hasOwnProperty(key)) {
                const date = new Date(key);
                transformed[date.getDate()] = {
                    date: new Date(key),
                    count: days[key]
                };
            }
        }
        console.log('Transformed days:', transformed);
        return transformed;
    },

    getYears: function() {
        if (this.yearsList) {
            return this.yearsList;
        }
        this.yearsList = JSON.parse(document.getElementById('miracleCalendarYears').textContent);
        return this.yearsList;
    },
    getYearInfo: function(year) {
        if (this.years[year]) {
            return this.years[year];
        }
        this.years[year] = JSON.parse(document.getElementById(`miracleCalendarYear_${year}`).textContent);
        return this.years[year];
    },
    getMonthInfo: function(year, month) {
        const yearInfo = this.getYearInfo(year);
        if (yearInfo.months && yearInfo.months[String(month).padStart(2, '0')]) {
            return yearInfo.months[String(month).padStart(2, '0')];
        }
        return null;
    },

    renderCalendar: function(date) {
        console.log('Rendering calendar for date:', date);

        const selectedDateObj = typeof date === 'string' ? new Date(date) : date;

        // selected ir kurš datums ir izvēlēts (uzspiests)
        this.selected = {
            date: selectedDateObj,
            year: selectedDateObj.getFullYear(),
            month: selectedDateObj.getMonth() + 1,
            day: selectedDateObj.getDate()
        }

        // opened var būt cits ja staigā pa kalendāru bet nav izvēlēts konkrēts datums
        this.opened = {
            year: selectedDateObj.getFullYear(),
            month: selectedDateObj.getMonth() + 1
        }


        this.renderYears();
        this.openYear();
        this.renderSelected();

        // Iegūtam info par izvēlēto gadu;
        /* const yearInfo = this.getYearInfo(this.opened.year);
        const notBefore = yearInfo.not_before ? new Date(yearInfo.not_before) : null;
        const notAfter = yearInfo.not_after ? new Date(yearInfo.not_after) : new Date();
        console.log('Opened year:', this.opened.year, 'notBefore is:', notBefore);

        this.renderMonths(notBefore, notAfter);

        const monthInfo = this.getMonthInfo(this.opened.year, this.opened.month);
        console.log('Month info:', monthInfo);
        const topDay = monthInfo && monthInfo.top_day ? new Date(monthInfo.top_day) : null;
        const activeDays = monthInfo && monthInfo.days ? this.transformDays(monthInfo.days) : {};
        this.renderDays(activeDays, topDay, notBefore, notAfter); */
    },
    openYear: function() {
        const yearInfo = this.getYearInfo(this.opened.year);
        const notBefore = yearInfo.not_before ? new Date(yearInfo.not_before) : null;
        const notAfter = yearInfo.not_after ? new Date(yearInfo.not_after) : new Date();
        console.log('Opened year:', this.opened.year, 'notBefore is:', notBefore);

        this.renderMonths(notBefore, notAfter);

        const monthInfo = this.getMonthInfo(this.opened.year, this.opened.month);
        console.log('Month info:', monthInfo);
        const topDay = monthInfo && monthInfo.top_day ? new Date(monthInfo.top_day) : null;
        const activeDays = monthInfo && monthInfo.days ? this.transformDays(monthInfo.days) : {};
        this.renderDays(activeDays, topDay, notBefore, notAfter);

        this.renderLabels();
    },
    openMonth: function() {
        const yearInfo = this.getYearInfo(this.opened.year);
        const notBefore = yearInfo.not_before ? new Date(yearInfo.not_before) : null;
        const notAfter = yearInfo.not_after ? new Date(yearInfo.not_after) : new Date();

        const monthInfo = this.getMonthInfo(this.opened.year, this.opened.month);
        console.log('Month info:', monthInfo);
        const topDay = monthInfo && monthInfo.top_day ? new Date(monthInfo.top_day) : null;
        const activeDays = monthInfo && monthInfo.days ? this.transformDays(monthInfo.days) : {};
        this.renderDays(activeDays, topDay, notBefore, notAfter);

        this.renderLabels();
    },
    renderYears: function() {
        // Iegūstam info par gadiem un uzģenerējam gadu izvēles pogas
        const availableYears = this.getYears();
        const yearButtonsContainer = this.dialog.getElementsByClassName('filter-years-list')[0];
        yearButtonsContainer.innerHTML = '';

        const bufferBefore = document.createElement('li');
        bufferBefore.classList.add('buffer');
        bufferBefore.innerHTML = '&nbsp;';
        yearButtonsContainer.appendChild(bufferBefore);

        availableYears.forEach(year => {
            const li = document.createElement('li');
            const button = document.createElement('button');
            button.setAttribute('data-year', year);
            button.textContent = year;
            if (year === this.opened.year) {
                button.classList.add('selected');
            }
            li.appendChild(button);
            yearButtonsContainer.appendChild(li);
        });

        const bufferAfter = document.createElement('li');
        bufferAfter.classList.add('buffer');
        bufferAfter.innerHTML = '&nbsp;';
        yearButtonsContainer.appendChild(bufferAfter);

        const selectedButton = yearButtonsContainer.querySelector('button.selected');
        if (selectedButton) {
            selectedButton.scrollIntoView({
                behavior: 'smooth',
                inline: 'center', // Iespējas: 'center', 'nearest', 'start'
                block: 'nearest'
            });
        }
    },
    renderMonths: function(_notBefore, _notAfter) {
        const notBefore = _notBefore && this.opened.year === _notBefore.getFullYear() ? _notBefore : null;
        const notAfter = _notAfter && this.opened.year === _notAfter.getFullYear() ? _notAfter : null;

        // Aktivizējam / Deaktivizējam nevajadzīgos mēnešus;
        const monthButtons = this.dialog.getElementsByClassName('filter-month-list')[0].getElementsByTagName('button');
        for (let i = 0; i < monthButtons.length; i++) {
            const month = parseInt(monthButtons[i].getAttribute('data-month'), 10);
            if (notBefore && month < (notBefore.getMonth() + 1)) {
                monthButtons[i].disabled = true;
            } else if (notAfter && month > (notAfter.getMonth() + 1)) {
                monthButtons[i].disabled = true;
            } else {
                monthButtons[i].disabled = false;
            }
            if (month === this.opened.month) {
                monthButtons[i].classList.add('selected');
            } else {
                monthButtons[i].classList.remove('selected');
            }
        }

        const selectedMonthButton = Array.from(monthButtons).find(button => button.classList.contains('selected'));
        if (selectedMonthButton) {
            selectedMonthButton.scrollIntoView({
                behavior: 'smooth',
                inline: 'center', // Iespējas: 'center', 'nearest', 'start'
                block: 'nearest'
            });
        }
    },
    renderDays: function(activeDays, topDay, _notBefore, _notAfter) {
        // izveidojam kalendāra skatu pa nedēļām;
        const daysContainer = this.dialog.getElementsByClassName('calendar-dyn-container')[0];
        daysContainer.innerHTML = '';

        const firstDayOfMonth = new Date(this.opened.year, this.opened.month - 1, 1);
        const lastDayOfMonth = new Date(this.opened.year, this.opened.month, 0);

        const startDay = firstDayOfMonth.getDay();
        const totalDays = lastDayOfMonth.getDate();

        const currentDate = new Date();
        const isCurrentMonth = currentDate.getFullYear() === this.opened.year && currentDate.getMonth() + 1 === this.opened.month;
        const notBefore = _notBefore && _notBefore.getFullYear() === this.opened.year && _notBefore.getMonth() + 1 === this.opened.month ? _notBefore : null;
        const notAfter = _notAfter && _notAfter.getFullYear() === this.opened.year && _notAfter.getMonth() + 1 === this.opened.month ? _notAfter : null;

        const isSelectedMonth = this.selected.year === this.opened.year && this.selected.month === this.opened.month;

        let currentWeek = document.createElement('div');
        currentWeek.classList.add('calendar-grid', 'week');

        console.log('Rendering days for month:', this.opened.month, 'year:', this.opened.year, activeDays);
        console.log('notBefore:', notBefore, 'notAfter:', notAfter);

        // pievienojam tukšās dienas nedēļas sākumā, ja mēnesis nesākas ar pirmdienu
        for (let i = 0; i < startDay; i++) {
            const emptyCell = document.createElement('div');
            emptyCell.classList.add('calendar-day', 'empty');
            currentWeek.appendChild(emptyCell);
        }

        let day = 1;
        while (day <= totalDays) {
            const isActive = activeDays[day] ? true : false;
            const isToday = isCurrentMonth && currentDate.getDate() === day;
            const dayCell = document.createElement(isActive || isToday ? 'button' : 'div');
            dayCell.classList.add('calendar-day');
            if (notBefore && day < notBefore.getDate()) {
                dayCell.classList.add('disabled');
            } else if (notAfter && day > notAfter.getDate()) {
                dayCell.classList.add('disabled');
            }
            if (isActive) {
                dayCell.classList.add('usable');
                if (activeDays[day].count) {
                    dayCell.setAttribute('data-count', activeDays[day].count);
                }
                if (isSelectedMonth && this.selected.day === day) {
                    dayCell.classList.add('selected');
                }
            }
            dayCell.textContent = day.toString();

            if (isToday) {
                dayCell.classList.add('today');
            }
            currentWeek.appendChild(dayCell);

            day++
            if (day > totalDays) {
                // Fill the remaining cells of the week with empty cells
                while (currentWeek.children.length < 7) {
                    const emptyCell = document.createElement('div');
                    emptyCell.classList.add('calendar-day', 'empty');
                    currentWeek.appendChild(emptyCell);
                }
                break;
            }
            // If the current week is full, append it to the container and start a new week
            if (currentWeek.children.length === 7) {
                daysContainer.appendChild(currentWeek);
                currentWeek = document.createElement('div');
                currentWeek.classList.add('calendar-grid', 'week');
            }
        }
        if (currentWeek.children.length > 0) {
            // Append the last week if it has any days
            daysContainer.appendChild(currentWeek);
        }

        if (this.focusTrap) {
            this.focusTrap.refresh();
        }
    },
    renderLabels: function() {
        if (!this.labels) return;
        const container = this.dialog.querySelector('.month-stats');
        if (!container) return;
        container.innerHTML = '';

        const monthInfo = this.getMonthInfo(this.opened.year, this.opened.month);
        const topActivity = monthInfo.days[monthInfo.top_day] || 0;
        const topDate = monthInfo.top_day ? new Date(monthInfo.top_day) : null;
        const miracles = monthInfo.total || 0;
        const replacements = {
            '%month%': transGet('MONTH_'+this.opened.month.toString().padStart(2, '0')),
            '%miracles%': miracles,
            '%top_activity%': topActivity,
            '%top_day_of_week%': topDate ? topDate.toLocaleDateString('en-US', { weekday: 'long' }) : '',
            '%top_date%': topDate ? this.formatDate(topDate) : ''
        }
        var text = this.labels['WMMCAL_MonthStat'+(miracles > 1 ? 2 : 1)] || '';
        text = text.replace(/%\w+%/g, (match) => replacements[match] || '');
        container.innerHTML = text;
    },
    renderSelected: function() {
        if (!this.labels) return;
        const container = this.dialog.querySelector('.selected-stats');
        if (!container) return;
        container.innerHTML = '';

        const monthInfo = this.getMonthInfo(this.selected.year, this.selected.month);
        const dateString = this.selected.year + '-' + this.selected.month.toString().padStart(2, '0') + '-' + this.selected.day.toString().padStart(2, '0');
        const miracles = monthInfo.days[dateString] || 0;
        const replacements = {
            '%dd%': this.selected.day,
            '%month%': transGet('MONTH_'+this.selected.month.toString().padStart(2, '0')),
            '%year%': this.selected.year,
            '%miracles%': miracles
        }
        var text = this.labels['WMMCAL_DayStat'+(miracles > 1 ? 2 : 1)] || '';
        text = text.replace(/%\w+%/g, (match) => replacements[match] || '');
        container.innerHTML = text;

        const currentDate = new Date();
        const isCurrentDate = this.selected.year === currentDate.getFullYear() &&
                              this.selected.month === (currentDate.getMonth() + 1) &&
                              this.selected.day === currentDate.getDate();

        const watchButton = this.dialog.querySelector('.watch-button');
        console.log(this.selected.year, currentDate.getFullYear());
        console.log(this.selected.month, (currentDate.getMonth() + 1));
        console.log(this.selected.day, currentDate.getDate());
        console.log(watchButton, isCurrentDate);
        if (isCurrentDate) {
            watchButton.classList.add('islive');
            watchButton.classList.remove('isplay');
        } else {
            watchButton.classList.add('isplay');
            watchButton.classList.remove('islive');
        }

    },
    formatDate: function(date) {
        const yyyy = date.getFullYear();
        let mm = date.getMonth() + 1; // Months start at 0!
        let dd = date.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        return dd + '.' + mm + '.' + yyyy;
    },
    open: function() {
        callDynEvents(this.$field, 'beforeShow');

        this.show();

        callDynEvents(this.$field, 'afterShow');
    },

    backTo: function (toLevel, nohistory = false) {
        const targetLevel = toLevel || 0;

        if (this.historyLevel < 1) {
            return;
        }

        if (this.historyLevel === 1 && this.historyLevel > targetLevel) {
            this.close(nohistory);
            return;
        }
    },
    close: function (nohistory = false) {
        if (!nohistory && (typeof appState.historyInstance != 'undefined') && appState.historyInstance) {
            appState.historyInstance.go(-1);
            return;
        }

        if (this.modalManagerToken) {
            ModalManager.close(this.modalManagerToken);
            this.modalManagerToken = null;
        }

        if (typeof this.onCloseCallback === 'function') {
            this.onCloseCallback(this.result);
        }

        this.$field.css('pointer-events', 'none');

        const $animateleft = this.$field.find('.animateleft');
        /* $animateleft.on('transitionend', () => {
            $animateleft.off('transitionend');
            $animateleft.removeClass('off');
        }); */
        $animateleft.removeClass('disabled');
        $animateleft.removeClass('left');

        const animateEl = $animateleft.get(0);
        const endListener = (e) => {
            if (e.propertyName !== 'transform') return;
            $animateleft.off('transitionend');
            $animateleft.removeClass('off');
            animateEl.removeEventListener('transitionend', endListener);
        };
        animateEl.addEventListener('transitionend', endListener);

        if (this.focusTrap) {
            this.focusTrap.destroy();
            this.focusTrap = null;
        }

        this.isOpen = false;
        this.onSelectCallback = null;
        this.onCloseCallback = null;
    },
    show: function (nohistory = false) {
        if (this.modalManagerToken) {
            ModalManager.close(this.modalManagerToken);
        }
        this.modalManagerToken = ModalManager.open({
            name: this.historyParam,
            locksScroll: !!this.disableScroll
        });

        const $animateleft = this.$field.find('.animateleft');
        this.$field.css('pointer-events', 'none');

        this.scrollDialog(0);

        $animateleft.addClass('left');
        const animateEl = $animateleft.get(0);
        const endListener = (e) => {
            if (e.propertyName !== 'transform') return;
            $animateleft.off('transitionend');
            $animateleft.addClass('off disabled');
            this.$field.css('pointer-events', 'auto');
            this.isOpen = true;
            animateEl.removeEventListener('transitionend', endListener);
        };
        animateEl.addEventListener('transitionend', endListener);

        this.focusTrap = trapFocus(this.$field.get(0), (key) => {
            if (key === 'Escape') {
                if (this.isOpen) {
                    this.close();
                }
                return false;
            }
        });

        if (!nohistory) {
            this.historyLevel = 1;
            appState.historyInstance.push(this.historyParam, { value: this.historyLevel });
        }
    },
    scrollDialog: function (top) {
        const scrollContainer = this.$field.find('.scrollthis').get(0);
        scrollContainer.scrollTop = top;
        this.$field.get(0).offsetHeight; // Vienkārši nolasām augstumu, kas uztaisa "Force Reflow"
    },

};